/**
 * Created by spepa on 09.09.2024
 */

const ReportLevelOutcomeAction = function (f) {
    if (cleverapps.instantTournament.isAvailable()) {
        cleverapps.instantTournament.reportScore();
    } else {
        cleverapps.scoreTracker.report();
    }

    if (cleverapps.platformLogic.reportGameOver && this.game.outcome !== GameBase.OUTCOME_VICTORY) {
        cleverapps.platformLogic.reportGameOver();
    } else if (cleverapps.platformLogic.reportLevelUp && this.game.outcome === GameBase.OUTCOME_VICTORY) {
        cleverapps.platformLogic.reportLevelUp();
    }

    f();
};